import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Lookup from '@/api/lookup/api-lookup';
import { firstListItem } from '@/constants/defaultValues';
import { getLabel } from '@/helpers/Utils';

export const fetchTargetEmployees = createAsyncThunk(
  'company/fetchTargetEmployeesSlice',
  async (params, thunkAPI) => {
    try {
      const response = await Lookup.GetAllTargetEmployees();
      const mappedData =
        response?.data?.data?.map((item) => ({
          id: item.targetEmployeesID,
          targetEmployeesTypeID: item.targetEmployeesTypeID,
          targetEmployeesID: item.targetEmployeesID,
          targetEmployeesTypeName: item.targetEmployeesTypeName,
          type: item.targetEmployeesTypeID,
          nameEn: item.nameEn,
          nameAr: item.nameAr,
          label: getLabel(item.nameAr, item.nameEn),
          value: item.targetEmployeesID,
        })) ?? [];
      return [firstListItem, ...mappedData];
    } catch (error) {
      console.log(error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const initialState = {
  targetEmployeesList: [],
  loading: false,
  error: '',
};

const targetEmployeesSlice = createSlice({
  name: 'targetEmployee',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTargetEmployees.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTargetEmployees.fulfilled, (state, action) => {
        state.loading = false;
        state.targetEmployeesList = action.payload;
        state.error = '';
      })
      .addCase(fetchTargetEmployees.rejected, (state, action) => {
        state.loading = false;
        state.targetEmployeesList = [];
        state.error = action.payload ?? 'An error occurred';
      });
  },
});

export default targetEmployeesSlice.reducer;
